import { combineReducers } from "redux";
import authen from "./authenReducer";
import apiCallsInProgress from "./apiStatusReducer";
import activityFrameReducer from "./activityFrameSlice.js";
import dashboardFrameSlice from "./dashboardFrameSlice.js";
import dashFrameSlice from "./dashFrameSlice.js";
import patientFrameSlice from "./patientFrameSlice.js";
import fullPatientFrameSlice from "./fullPatientFrameSlice.js";
import skipAnalysisSlice from "./skipAnalysisSlice.js";
import fullSkipAnalysisSlice from "./fullSkipAnalysisSlice.js";
import reviewFrameSlice from "./reviewFrameSlice.js";
import filingRulesSlice from "./filingRulesSlice.js";
import ruleFrameSlice from "./ruleFrameSlice.js";
import bloodTestsSlice from "./bloodTestSlice.js";
import rulesetSlice from "./rulesetSlice.js";
import credentialsSlice from "./credentialsSlice.js";
import settingsSlice from "./settingsSlice.js";
import rulesInReviewSlice from "./rulesInReviewSlice";
import categoryGroupsSlice from "./categoryGroupsSlice";
import secondaryAccountSlice from "./secondaryAccountSlice.js";

const appReducer = combineReducers({
  authen,
  activityFrame: activityFrameReducer,
  rulesInReview: rulesInReviewSlice,
  dashboardFrame: dashboardFrameSlice,
  categoryGroups: categoryGroupsSlice,
  skipAnalysis: skipAnalysisSlice,
  fullSkipAnalysis: fullSkipAnalysisSlice,
  dashFrame: dashFrameSlice,
  pathologySearch: patientFrameSlice,
  fullPathologySearch: fullPatientFrameSlice,
  reviewFrame: reviewFrameSlice,
  filingRules: filingRulesSlice,
  ruleFrame: ruleFrameSlice,
  bloodTests: bloodTestsSlice,
  ruleset: rulesetSlice,
  credentials: credentialsSlice,
  settings: settingsSlice,
  secondaryAccount: secondaryAccountSlice,
  apiCallsInProgress,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
